import "./frontend.scss"
//import javascript
// import './all-medewerkers-grid/frontend.js';
import './medewerkers-info/frontend.js';
